export const QUESTION_TYPES = {
    COPY: "copy",
    TEXT_GRAPHIC_ANSWER: "text_graphic_answer",
    TEXT_MEDIA_ANSWER: "text_media_answer",
    MULTIPLE_ANSWER: "multiple_answer",
    SINGLE_ANSWER: "single_answer",
    CONFORMITY_ANSWER: "conformity_answer",
    FILL_GAPS: "fill_gaps",
    INTERVIEW: "interview",
    LIKERT_SCALE: "likert_scale",
    SORTING: "sorting",
    COMPETITION: "competition",
    MIXED: "mixed",
    DEFAULT: "default",
    WORD_FROM_CHARS: "word_from_chars",
    REACTION: "reaction",
    RATING: "rating",
    YES_NO: "yes_no",
    WORD_ORDER: "sentence_from_words",
    NET_PROMOTE: "new_promoter_score",
    PASTE_WORD: "paste_word",
    CHOOSE_FROM_LIST: "choose_from_list",
    MULTI_CHOOSE_FROM_LIST: "multi_choose_from_list",
    MMPI: "mmpi",
    SHORT_TEXT_ANSWER: "short_text",
    EMAIL: "email",
    DATE: "date",
    LONG_TEXT_ANSWER: "long_text",
    AUDIO_ANSWER: "audio_answer",
    VIDEO_ANSWER: "video_answer",
    FILE_ANSWER: "file_answer",
    TITLE: "title",
    PARAGRAPH: "paragraph",
    IMAGE: "image",
    VIDEO: "video"
}

export const APPROVE_SETTINGABLE_TYPES = [
    QUESTION_TYPES.MULTIPLE_ANSWER,
    QUESTION_TYPES.FILL_GAPS,
    QUESTION_TYPES.CONFORMITY_ANSWER
]

export const TEXT_ANSWER_TYPES = {
    NONE: 1,
    INPUT: 2,
    AREA: 3,
    EMAIL: 4,
    DATE: 5
}

export const isTextMediaAnswer = question => {
    return [
        QUESTION_TYPES.SHORT_TEXT_ANSWER,
        QUESTION_TYPES.EMAIL,
        QUESTION_TYPES.DATE,
        QUESTION_TYPES.LONG_TEXT_ANSWER,
        QUESTION_TYPES.AUDIO_ANSWER,
        QUESTION_TYPES.VIDEO_ANSWER,
        QUESTION_TYPES.FILE_ANSWER,
        QUESTION_TYPES.TEXT_MEDIA_ANSWER
    ].includes(question.type.slug)
}

export const isMedia = question => {
    return [QUESTION_TYPES.TITLE, QUESTION_TYPES.PARAGRAPH, QUESTION_TYPES.IMAGE, QUESTION_TYPES.VIDEO].includes(
        question.type.slug
    )
}
